/*
 *   File : chip.js
 *   Author : https://evoqins.com
 *   Description : Chip component
 *   Integrations : NA
 *   Version : 1.0.0
 */

// custom packages
import React from "react";
import Icon from "../icons";
const Chip = (props) => {
  return (
    <div
      className={`${props.borderColor} rounded-pill px-3 py-2 ${props.Style} ${
        props.bgColor
      } ${props.icon && "d-flex gap-2px align-items-center"}  ${
        props.paddingBlock
          ? props.paddingBlock
          : "py-sm-1 e-py-2 padding-14px-lr"
      }`}
    >
      {props.icon && (
        // <img
        //   src={props.iconImg}
        //   alt={props.alt}
        //   className="e-chip-res"
        //   width={20}
        //   height={20}
        // />
        <Icon size="20px" icon={props.icon} />
      )}

      <p
        className={`${props.fontColor} ${
          props.fontWeight ? props.fontWeight : "e-font-weight-400"
        } text-capitalize mb-0 ${
          props.font ? props.font : "e-primary-font-poppins"
        }  ${props.fontSize ? props.fontSize : "e-font-12"}`}
      >
        {props.label}
      </p>
    </div>
  );
};

Chip.defaultProps = {
  onClick: () => {},
  type: 1,
};

export default Chip;
